import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { AuthModule } from './core/authentication/auth/auth.module';
import { WebStorageModule } from 'ngx-store';
import { CountDownComponent } from './modules/flow/components/count-down/count-down.component';
import { DataChangesGuard } from './core/guards/app-routing/can-deactivate.guard';
import { AddCollectionsComponent } from './modules/analytics-settings/components/add-collections/add-collections.component';
import { KeywordsModule } from './modules/keywords/keywords.module';
import { ApiIntegrationModule } from './modules/api-integration/api-integration.module';
import { RoutingModule } from './modules/routing/routing.module';
import { AssetsLibraryModule } from './modules/assets-library/assets-library.module';
import { FlowModule } from './modules/flow/flow.module';
import { SettingsModule } from './modules/settings/settings.module';
import { CoreModule } from './core/core.module';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { EffectsModule } from '@ngrx/effects';

import {
  DeployFlowEffects,
  emulatorReducer,
  EntityConfigEffects,
  entityConfigReducer,
  FlowEffects,
  flowModeReducer,
  modalConfigReducer,
  toastBannerReducer
} from "./core";
import {chatHubProviderEffects} from "./core/state/effects/flow-chatHub.effect";
import { AnalyticsSettingsComponent } from './modules/analytics-settings/analytics-settings.component';
import { DeleteCollectionComponent } from './modules/analytics-settings/components/delete-collection/delete-collection.component';

const stores = {
  flow: flowModeReducer,
  entityConfig: entityConfigReducer,
  config: modalConfigReducer,
  toastBanner: toastBannerReducer,
  emulator: emulatorReducer
};

const effects = [
  EntityConfigEffects,
  DeployFlowEffects,
  FlowEffects,
  chatHubProviderEffects
];

@NgModule({
  declarations: [AppComponent, CountDownComponent, AnalyticsSettingsComponent, AddCollectionsComponent, DeleteCollectionComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AuthModule,
    WebStorageModule,
    SharedModule,
    KeywordsModule,
    ApiIntegrationModule,
    RoutingModule,
    FlowModule,
    SettingsModule,
    AssetsLibraryModule,
    CoreModule,
    StoreModule.forRoot(stores),
    EffectsModule.forRoot(effects),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: !environment.production,
      autoPause: true,
    }),

  ],
  providers: [DataChangesGuard],
    exports: [
        AnalyticsSettingsComponent
    ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class AppModule {}
